import type { FIXED_INDENTS } from 'vars/fixed-indents'

import { styled } from '@linaria/react'
import { INDENTS } from 'vars/indents'
import { MEDIA } from 'vars/media'

export const PlayerSignToWatchPopupSC = styled.div<{ gap: FIXED_INDENTS }>`
  display: flex;
  position: absolute;
  top: 50vh;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100vw;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: var(${INDENTS.INDENT_50});
  gap: ${({ gap }) => `var(${gap})`};
  width: 22.5rem;

  ${MEDIA.MIN_600} {
    width: 100%;
  }

  ${MEDIA.MIN_1240} {
    width: 27rem;
  }
`

export const PlayerSignToWatchPopupSmallSC = styled.div<{ gap: FIXED_INDENTS }>`
  display: flex;
  position: relative;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: var(${INDENTS.INDENT_25});
  gap: ${({ gap }) => `var(${gap})`};
`

export const PlayerSignToWatchBtnWrapperSC = styled.div``
